import { logger } from "@src/shared/helpers/logger";
import { isNullish } from "radashi";
import { engine } from "../..";
import { getSuggestionsArgsParams } from "./getSuggestionsArgsParams";
import { ValveSuggestionArgsOptions } from "./initSuggestionArgs";

export function initSmartControlValvesSuggestionArgs({
  filters,
  ...valveSuggestionArgs
}: ValveSuggestionArgsOptions) {
  if (isNullish(filters.flow)) {
    logger.warn(
      "Not initializing smart control valves suggestions args because of missing filters",
    );
    return { cleanup() {}, currentSelection: null, suggestionArgs: null };
  }
  const { cleanup, currentSelection, params } = getSuggestionsArgsParams({
    filters,
    ...valveSuggestionArgs,
  });
  const args = new engine.SmartValvesSuggestionArgs(...params);
  args.flow = filters.flow;

  return {
    cleanup() {
      cleanup();
      args.delete();
    },
    currentSelection,
    suggestionArgs: args,
  };
}
